import useSWR from 'swr';
import { datadogRum } from '@datadog/browser-rum';
import {
  useSidebar,
  SET_DATA,
  SET_FILTERED_DATA,
  SET_ERROR_MESSAGE,
  SET_IS_LOADING,
  SET_LOAD_ERROR,
} from '@/app/context/sidebarContext';
import { useEffect } from 'react';
import { getZocListKey } from '@/app/_hooks/fetchers/zoc';

const SwrLoader = () => {
  const [, dispatch] = useSidebar();

  const { data, isLoading } = useSWR(
    getZocListKey(),
    async (url) => {
      try {
        const res = await fetch(url);
        if (res.status === 401) {
          window.location.reload();
        }

        if (!res.ok) {
          // workaround for error handling locally
          const detail = await res.json();
          dispatch({ type: SET_LOAD_ERROR, payload: { loadError: true } });
          dispatch({
            type: SET_ERROR_MESSAGE,
            payload: { errorMessage: detail.message },
          });
          return;
        }
        datadogRum.addAction('Zoc list fetched ');
        const zocNotes = await res.json();
        return zocNotes;
      } catch (error: any) {
        // workaround for error handling locally
        dispatch({ type: SET_LOAD_ERROR, payload: { loadError: true } });
        dispatch({
          type: SET_ERROR_MESSAGE,
          payload: { errorMessage: 'Oops! Something went wrong...' },
        });
      }
    },
    { revalidateOnMount: true }
  );

  useEffect(() => {
    dispatch({ type: SET_IS_LOADING, payload: { isLoading: isLoading } });
    if (!isLoading) {
      dispatch({ type: SET_DATA, payload: { data: data } });
      dispatch({ type: SET_FILTERED_DATA, payload: { filteredData: data } });
    }
  }, [isLoading, data]);

  return <></>;
};

export default SwrLoader;
